import { render, staticRenderFns } from "./FortuneSpin.vue?vue&type=template&id=2f4b7548&scoped=true"
import script from "./FortuneSpin.vue?vue&type=script&lang=js"
export * from "./FortuneSpin.vue?vue&type=script&lang=js"
import style0 from "./FortuneSpin.vue?vue&type=style&index=0&id=2f4b7548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b7548",
  null
  
)

export default component.exports